/** @jsxImportSource @emotion/react */

import { useQuery } from '@apollo/client'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { omit } from 'lodash'
import { findOneVideoCategory, findOneVideoCategoryVariables } from '__generatedTypes__/findOneVideoCategory'
import { FIND_ONE_VIDEO_CATEGORY, FIND_ONE_VIDEOS } from 'queries/video'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { findOneVideo, findOneVideoVariables } from '__generatedTypes__/findOneVideo'
import { PageLoader } from 'components/PageLoader'

// TODO: this logic should be generalized for edit pages:
//  I want to see generic HOC in the future that accepts a query,
//  shows loader or error state or wrapped component depending on the state

// eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
const withVideoCategoryContentCheck = (Component: any) => () => {
  const { videoCategoryId = '', contentId = '' } = useParams()

  const { navigate } = useLink()

  const { data: videoCategoryData, loading: videoCategoryLoading } = useQuery<
    findOneVideoCategory,
    findOneVideoCategoryVariables
  >(FIND_ONE_VIDEO_CATEGORY, {
    variables: { findOneVideoCategoryId: videoCategoryId },
  })

  const { data: contentData, loading: contentLoading } = useQuery<findOneVideo, findOneVideoVariables>(
    FIND_ONE_VIDEOS,
    { variables: { findOneVideoId: contentId } }
  )

  const videoCategory = videoCategoryData?.findOneVideoCategory
  const content = omit(contentData?.findOneVideo, '__typename')

  const redirectToVideoDashboard = () => {
    navigate(cmsRoutes.VIDEO_DASHBOARD, undefined, {
      searchParams: new URLSearchParams({
        subjectId: String(videoCategory?.subject?.id),
        categoryId: String(videoCategory?.id),
      }),
    })
  }

  if (videoCategoryLoading || contentLoading) {
    return <PageLoader />
  }

  //TODO Error state
  if (!videoCategory) {
    return <Typography variant="title1">Video Category not found...</Typography>
  }

  //TODO Error state
  if (!content) {
    return <Typography variant="title1">Content not found...</Typography>
  }

  return (
    <Component videoCategory={videoCategory} content={content} redirectToVideoDashboard={redirectToVideoDashboard} />
  )
}

export default withVideoCategoryContentCheck
